import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const HeroSection = () => {
  return (
    <section className="relative h-screen flex items-start overflow-hidden">
      {/* Background Image - Desktop */}
      <div className="absolute inset-0 z-0 hidden sm:block">
        <img 
          src="/images/life-supply-chain-banner.svg" 
          alt="DZF Distribution Logistics" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-dark/80 via-dark/30 to-transparent"></div>
      </div>

      {/* Background Image - Mobile */}
      <div className="absolute inset-0 z-0 block sm:hidden">
        <img 
          src="/images/life-supply-chain-banner_mobile-01.svg" 
          alt="DZF Distribution Logistics" 
          className="w-full h-screen object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-dark/80 via-dark/30 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-white px-4 sm:px-6 md:px-8 lg:px-12 pt-32 sm:pt-40">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl text-left"
        >
          <h1 className="text-2xl md:text-4xl font-bold mb-6 [text-shadow:_2px_2px_4px_rgba(0,0,0,0.5)]">
            Votre partenaire de confiance pour développer vos produits au Canada
          </h1>
          <p className="text-sg mb-8 text-white">
            Experts en importation, logistique, conformité et chaîne d'approvisionnement internationale
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/contact" className="btn-secondary">
              Contactez-nous
            </Link>
            <Link to="/services" className="btn-outline border-white text-white hover:bg-white hover:text-dark">
              En savoir plus
            </Link>
          </div>
        </motion.div>
      </div>

      {/* Scroll Down Indicator */}
      <motion.div 
        className="absolute bottom-16 left-1/2 transform -translate-x-1/2 z-10"
        animate={{ y: [0, 10, 0] }}
        transition={{ repeat: Infinity, duration: 1.5 }}
      >
        <svg 
          width="40" 
          height="40" 
          viewBox="0 0 24 24" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
          className="text-white"
        >
          <path 
            d="M12 5L12 19M12 19L19 12M12 19L5 12" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
        </svg>
      </motion.div>
    </section>
  );
};

export default HeroSection; 